/* NEXby product page: sticky mobile add-to-cart bar. Mirrors the main button + price, shows when the main button leaves the viewport. */
(function () {
  var bar = document.querySelector('[data-nx-bar]');
  if (!bar || bar.dataset.nxReady) return;
  bar.dataset.nxReady = '1';

  var sectionId = bar.getAttribute('data-section-id');
  var btn = bar.querySelector('[data-nx-bar-btn]');
  var priceSlot = bar.querySelector('[data-nx-bar-price]');
  var root = document.getElementById('MainProduct-' + sectionId);
  if (!btn || !priceSlot || !root) return;

  var inView = true;
  var io = null;
  var observed = null;

  function mainButton() {
    return document.getElementById('ProductSubmitButton-' + sectionId);
  }

  function sync() {
    var main = mainButton();
    var label = main && main.querySelector('span');
    /* write only on change: the bar lives inside the observed root, so redundant writes would loop */
    var text = label ? label.textContent.trim() : '';
    if (btn.textContent !== text) btn.textContent = text;
    var off = !main || main.disabled || main.getAttribute('aria-disabled') === 'true';
    if (btn.disabled !== off) btn.disabled = off;

    var price = document.querySelector('#price-' + sectionId + ' .price');
    if (price && priceSlot.innerHTML !== price.innerHTML) priceSlot.innerHTML = price.innerHTML;

    if (main && main !== observed && io) {
      if (observed) io.unobserve(observed);
      io.observe(main);
      observed = main;
    }
  }

  function render() {
    var show = !inView;
    bar.classList.toggle('is-visible', show);
    bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    btn.tabIndex = show ? 0 : -1;
  }

  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      var entry = entries[entries.length - 1];
      /* only show once the button has scrolled above the viewport, not while it is still below the fold */
      inView = entry.isIntersecting || entry.boundingClientRect.top > 0;
      render();
    });
  }

  btn.addEventListener('click', function () {
    var main = mainButton();
    if (!main || main.disabled) return;
    var form = main.form || main.closest('form');
    if (form && form.requestSubmit) form.requestSubmit(main);
    else main.click();
  });

  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      sync();
    });
  }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });

  sync();
})();

/* The description often opens with its own "Product description" heading; the band above it already has one. */
(function () {
  var body = document.querySelector('.nx-pdp__details-body');
  if (!body) return;
  Array.prototype.forEach.call(body.querySelectorAll('h1, h2'), function (h) {
    if (h.textContent.trim().toLowerCase() === 'product description') h.hidden = true;
  });
})();
